import MainMenuItemList, { MainMenuItemListProps } from './MainMenuItemList';

export type { MainMenuItemListProps };
export default MainMenuItemList;
